/* TODO: delete this file and component */
import React, { useEffect, useState } from 'react';

import { Drawer, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { StyledAvatar } from 'components/avatars';
import { useMatchedRoute } from 'components/hooks/useMatchedRoute';
import { useDispatch, useSelector } from 'react-redux';
import { useProfilePage } from 'screens/Profile/hooks/dataHooks';
import SidepanelFooter from 'screens/admin/common/sidepanelFooter';
import SidepanelHeader from 'screens/admin/common/sidepanelHeader';
import useRouteQueryParams from 'screens/performanceReview/hooks/useRouteQueryParams';
import { selectLoggedInEmployeeId, selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';
import styled from 'styled-components';
import { CenterItemFlexContainer, FlexContainer, StyledTypography } from 'styles/common';

import CreateOneOnOneImage from 'assets/images/illustrations/oneOnOneCreate.png';

import { ONE_ON_ONE_EVENTS_OLD, sendCreatedOneonone, sendOneOnOneEvent } from 'constants/mixpanelHelper';
import { routes } from 'constants/routes';
import theme from 'constants/theme';

import { createOneOnOnes } from 'services/OneOnOne';
import { showErrorSnackbar } from 'services/snackbar';

import CheckInSelect from './CheckInSelect';
import SearchEmployees from './SearchEmployees';

const StyledImage = styled.img`
  max-width: 45%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SelectedEmployeesWrapper = styled.div`
  width: 70%;
  height: 30vh;
  overflow-y: auto;
  margin-top: 32px;
`;

const StyledSelectedEmployee = styled(FlexContainer)`
  align-items: center;
  background: #f7f7f7;
  border: 1px solid #eaeaea;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 24px;
  margin-bottom: 24px;
`;

const SelectedEmployee = ({ profilePhoto, displayName, id, isManager, onRemove, onRelationChange }) => (
  <StyledSelectedEmployee>
    <StyledAvatar size="tinier" rightGutter={3} alt={displayName} src={profilePhoto} />
    <FlexContainer style={{ flexGrow: '1' }}>
      <StyledTypography variant="body2" color={theme.palette.text.heading}>
        {displayName?.slice(0, 30)}
        {displayName?.length > 30 ? '...' : ''}
      </StyledTypography>
    </FlexContainer>
    <CheckInSelect defaultValue={isManager} onChange={(isManager) => onRelationChange(id, isManager)} />
    <FlexContainer style={{ alignItems: 'center', marginLeft: '48px' }}>
      <IconButton onClick={onRemove} size="small">
        <CloseIcon fontSize="small" />
      </IconButton>
    </FlexContainer>
  </StyledSelectedEmployee>
);

const SelectedEmployeeCountWrapper = styled(CenterItemFlexContainer)`
  width: 62px;
  height: 32px;
  background: #f7f7f7;
  border-radius: 4px;
`;

const SelectedEmployeeCount = ({ count }) => (
  <SelectedEmployeeCountWrapper>
    <StyledTypography variant="body2" color={theme.palette.text.label}>
      {count === 0 ? '-' : count < 10 ? `0${count}` : count}
    </StyledTypography>
  </SelectedEmployeeCountWrapper>
);

// using this in 1:1 landing page.
/**
 * @deprecated 8-04-2025
 */
const CreateCheckInSidepanel = ({
  isOpen,
  setIsOpen,
  currentOneOnOneEmployees,
  loggedInEmployeeId,
  forceUpdateParent,
}) => {
  const { employeeId } = useRouteQueryParams(routes.profile);
  const { pageName } = useMatchedRoute();
  const { data: employeeData, isLoading, isError } = useProfilePage({ employeeId });
  const { userRole } = useSelector(selectLoggedInEmployeeData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(null);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const excludeEmpIds = [...currentOneOnOneEmployees, ...selectedEmployees.map(({ id }) => id)];

  const selectedEmployeeData = {
    displayName: employeeData?.displayName,
    id: employeeData?.id,
    isManager: employeeData?.isManager(),
    profilePhoto: employeeData?.image,
  };

  const currentLoggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  useEffect(() => {
    !isOpen && setSelectedEmployees([]);
  }, [isOpen]);

  useEffect(() => {
    if (employeeId) currentLoggedInEmployeeId !== employeeId && setSelectedEmployees([selectedEmployeeData]);
  }, [employeeId]);

  const handleSave = () => {
    setLoading(true);
    const requestList = selectedEmployees.map(({ id, isManager }) => {
      if (isManager) {
        return { managerId: id, reporteeId: loggedInEmployeeId };
      }
      return { managerId: loggedInEmployeeId, reporteeId: id };
    });
    createOneOnOnes({ requestList })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'Sorry, unable to create 1:1', 5000));
      })
      .finally(() => {
        setLoading(false);
        handleClose();
        forceUpdateParent();
        sendOneOnOneEvent({
          eventName: ONE_ON_ONE_EVENTS_OLD.createdNewOneOnOne,
          page: {
            pageName,
            flow: 'Activity',
          },
        });
        sendCreatedOneonone({
          eventProperties: {
            relationship: userRole,
          },
        });
      });
  };

  const handleClose = () => setIsOpen(false);

  const handleKeyDown = ({ keyCode }) => {
    if (keyCode === 27) handleClose();
  };

  const onSelect = (employee) => {
    setSelectedEmployees((oldList) => [{ ...employee, isManager: false }, ...oldList]);
  };

  const removeSelection = (empId) => {
    setSelectedEmployees((oldList) => oldList.filter(({ id }) => id !== empId));
  };

  const handleOnRelationChange = (empId, isManager) => {
    setSelectedEmployees((oldList) =>
      oldList.map((emp) => {
        if (emp?.id === empId) {
          return { ...emp, isManager };
        }
        return emp;
      })
    );
  };

  return (
    <StyledDrawer
      ModalProps={{
        onBackdropClick: () => {
          handleClose();
        },
      }}
      anchor="right"
      open={isOpen}
      onKeyDown={handleKeyDown}
    >
      <SidepanelHeader onCancel={() => handleClose()} withBottomBorder={false} />

      <ContentWrapper>
        <StyledImage src={CreateOneOnOneImage} />
        <StyledTypography
          bottomGutter={1.5}
          topGutter={5}
          variant="h6"
          style={{ fontSize: '20px' }}
          weight={600}
          color={theme.palette.text.heading}
        >
          Add New 1:1
        </StyledTypography>
        <StyledTypography bottomGutter={6} variant="caption" color={theme.palette.text.label}>
          You can search and add employees from your organization
        </StyledTypography>
        <SearchEmployees exclusions={excludeEmpIds} onSelect={onSelect} />
        <SelectedEmployeesWrapper>
          {selectedEmployees.map((emp) => (
            <SelectedEmployee
              key={emp.id}
              {...emp}
              onRemove={() => removeSelection(emp.id)}
              onRelationChange={handleOnRelationChange}
            />
          ))}
        </SelectedEmployeesWrapper>
      </ContentWrapper>
      <SidepanelFooter
        onSave={handleSave}
        onCancel={handleClose}
        loading={loading}
        primaryActionText="Add"
        disabled={selectedEmployees.length === 0}
        leftComponent={<SelectedEmployeeCount count={selectedEmployees.length} />}
      />
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  position: relative;
  .MuiDrawer-paper {
    width: 40%;
  }
`;

export default CreateCheckInSidepanel;
